import { render, staticRenderFns } from "./InquiryButton.vue?vue&type=template&id=82d6847a&scoped=true"
import script from "./InquiryButton.vue?vue&type=script&lang=js"
export * from "./InquiryButton.vue?vue&type=script&lang=js"
import style0 from "./InquiryButton.vue?vue&type=style&index=0&id=82d6847a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d6847a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
